import {StyleSheet, PixelRatio} from 'react-native';
import {getScreenSize, scale} from "../../../../../../common/utils";

export default StyleSheet.create({
    searchPlaceBoxWrapper:{
        height: scale(56)
    },
    searchPlaceBox:{
        flexDirection:'row',
        justifyContent:'space-between',
        alignItems:'center',
        position: 'relative'
    },
    searchPlaceNoCityText:{
        color: '#999',
        fontSize: scale(14),
        maxWidth: scale(120)
    },
    searchIcon:{
        position: 'absolute',
        width: scale(36),
        height: scale(36),
        left: '50%',
        top: '50%',
        marginTop: scale(-18),
        marginLeft: scale(-18),
        zIndex: 10,
    },
    searchIconFlight:{
        position: 'absolute',
        width: scale(24),
        height: scale(24),
        left: '50%',
        top: '50%',
        marginLeft: scale(-10.5),
        marginTop: scale(-12)
    },
    searchIconCircle:{
        width: scale(36),
        height: scale(36),
        transform: [{
            rotateZ: '0deg'
        }]
    },
    searchPlaceText:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: scale(24),
        color: "#212121",
        height: scale(56),
        minWidth: scale(getScreenSize().width / 2 - 60),
        lineHeight: scale(56),
        maxWidth: scale(120)
    },

    arr:{
        textAlign: 'right'
    },

    searchMaxWidth:{
        fontSize: scale(18),
        maxWidth: scale(127)
    }
});
